import styled, { createGlobalStyle } from "styled-components";
import LidlFontProBookWoff2 from "./fonts/LidlFontPro-Book.woff2";
import LidlFontProBookWoff from "./fonts/LidlFontPro-Book.woff";
import LidlFontProBoldWoff2 from "./fonts/LidlFontPro-Bold.woff2";
import LidlFontProBoldWoff from "./fonts/LidlFontPro-Bold.woff";
import LidlFontCondProRegularWoff2 from "./fonts/LidlFontCondPro-Regular.woff2";
import LidlFontCondProRegularWoff from "./fonts/LidlFontCondPro-Regular.woff";
import LidlFontCondProBoldWoff2 from "./fonts/LidlFontCondPro-Bold.woff2";
import LidlFontCondProBoldWoff from "./fonts/LidlFontCondPro-Bold.woff";

export const LidlFontProBookFont = createGlobalStyle`
@font-face {
  font-family: "LidlFontProBook";
  src:
    url(${LidlFontProBookWoff2}) format("woff2"),
    url(${LidlFontProBookWoff}) format("woff");
  font-style: normal;
  font-weight: 400;
  font-display: auto;
}
`;

export const LidlFontProBoldFont = createGlobalStyle`
@font-face {
  font-family: "LidlFontProBold";
  src:
    url(${LidlFontProBoldWoff2}) format("woff2"),
    url(${LidlFontProBoldWoff}) format("woff");
  font-style: normal;
  font-weight: 700;
  font-display: auto;
}
`;

export const LidlFontCondProRegularFont = createGlobalStyle`
@font-face {
  font-family: "LidlFontCondProRegular";
  src:
    url(${LidlFontCondProRegularWoff2}) format("woff2"),
    url(${LidlFontCondProRegularWoff}) format("woff");
  font-style: normal;
  font-weight: 400;
  font-display: auto;
}
`;

export const LidlFontCondProBoldFont = createGlobalStyle`
@font-face {
  font-family: "LidlFontCondProBold";
  src:
    url(${LidlFontCondProBoldWoff2}) format("woff2"),
    url(${LidlFontCondProBoldWoff}) format("woff");
  font-style: normal;
  font-weight: 700;
  font-display: auto;
}
`;

const textLight = {
  fontFamily: "LidlFontProBook",
  fontWeight: 400,
  color: "#ffffff"
};

const textBold = {
  fontFamily: "LidlFontCondProBold",
  fontWeight: 700,
  color: "#ffffff"
};

const columnCenter = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center"
};

export const MainContainer = styled.div`
  ${columnCenter}
  width: 100%;
  max-width: 383px;
  margin: auto;
  min-height: 100vh;
  background-color: #0052ae;
`;

export const HeaderSection = styled.header`
  ${columnCenter}
  width: 100%;
  padding: 18px 20px 16px;
  border-bottom: 1px solid #ffffff;

  img {
    width: 171px;
    height: auto;
    margin-bottom: 2px;
  }

  p {
    font-family: "LidlFontProBook";
    font-weight: 400;
    color: #ffffff;
    font-size: 11px;
    line-height: 16px;
    margin: 0 0 8px 0;
  }

  h1 {
    color: rgba(255, 255, 255, 0.92);
    text-align: center;
    font-feature-settings:
      "liga" off,
      "clig" off;
    font-family: "LidlFontProBold";
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin: 0;
  }

  span {
    display: block;
    margin-top: 2px;
  }
`;

export const WelcomeSection = styled.section`
  ${columnCenter}
  width: 100%;
  padding: 4px 21px 30px;

  h2 {
    color: #ffffff;
    text-align: center;
    font-feature-settings:
      "liga" off,
      "clig" off;
    font-family: "LidlFontProBold";
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
    margin: 0 0 14px;
  }

  p {
    ${textLight}
    font-feature-settings:
      "liga" off,
      "clig" off;
    font-size: 16px;
    font-style: normal;
    line-height: 24px;
    letter-spacing: 0.5px;
    text-align: center;
    margin: 0 0 12px;
  }
`;

export const BottomImageSection = styled.section`
  width: 100%;
  margin-top: auto;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const FooterSection = styled.footer`
  ${columnCenter}
  width: 100%;
  padding: 20px 16px 28px;
  background: #01224b;

  p {
    ${textBold}
    font-size: 13px;
    line-height: 16px;
    margin: 0 0 8px;
  }

  img {
    width: 114px;
    height: auto;
    margin-bottom: 14px;
  }

  a {
    ${textLight}
    font-feature-settings:
      "liga" off,
      "clig" off;
    font-style: normal;
    font-size: 15px;
    line-height: 24px;
    text-decoration: none;
    margin: 0;
  }
`;
